<template>
  <div class="app-container">
    <div class="filter-container">
      <el-input
        v-model="listQuery.shop_name"
        placeholder="店铺名"
        style="width: 200px;"
        class="filter-item"
        :clearable="true"
      />
      <el-input
        v-model="listQuery.order_no"
        placeholder="订单编号"
        style="width: 200px;"
        class="filter-item"
        :clearable="true"
      />
      <el-input
        v-model="listQuery.title"
        placeholder="标题"
        style="width: 200px;"
        class="filter-item"
        :clearable="true"
      />
      <el-input
        v-model="listQuery.name"
        placeholder="联系人"
        style="width: 200px;"
        class="filter-item"
        :clearable="true"
      />
      <el-input
        v-model="listQuery.phone"
        placeholder="电话"
        style="width: 200px;"
        class="filter-item"
        :clearable="true"
      />
      <el-select
        v-model="listQuery.type"
        placeholder="类型"
        :clearable="true"
        style="width: 110px"
        class="filter-item"
      >
        <el-option label="套餐" value="1" />
        <el-option label="路线" value="2" />
      </el-select>
      <el-select
        v-model="listQuery.order_status"
        placeholder="状态"
        :clearable="true"
        style="width: 150px"
        class="filter-item"
      >
        <el-option label="待付款" value="0" />
        <!-- <el-option label="进入拼团状态" value="1" /> -->
        <el-option label="待使用" value="2" />
        <!-- <el-option label="进入预约状态" value="3" /> -->
        <el-option label="使用中" value="4" />
        <el-option label="完成" value="5" />
        <el-option label="已关闭" value="7" />
        <el-option label="售后待处理" value="6" />
        <el-option label="售后成功" value="8" />
        <el-option label="售后失败" value="9" />
      </el-select>
      <el-button class="filter-item" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
    </div>
    <el-table
      v-loading="listLoading"
      :data="list"
      element-loading-text="Loading"
      border
      fit
      highlight-current-row
    >
      <el-table-column align="center" label="序号" width="95">
        <template slot-scope="scope">{{ scope.$index + 1 }}</template>
      </el-table-column>
      <el-table-column label="所在店铺" min-width="110" align="center">
        <template slot-scope="scope">
          {{
          scope.row.input_shop_id!=0 ? scope.row.shop.name : "平台自营"
          }}
        </template>
      </el-table-column>
      <el-table-column label="订单编号" min-width="110" align="center">
        <template slot-scope="scope">{{ scope.row.order_no }}</template>
      </el-table-column>
      <el-table-column label="头像" min-width="110" align="center">
        <template slot-scope="scope">
          <img :src="scope.row.user.avatar" class="user-avatar" />
        </template>
      </el-table-column>
      <el-table-column label="昵称" min-width="110" align="center">
        <template slot-scope="scope">{{ scope.row.user.nickname }}</template>
      </el-table-column>
      <el-table-column label="姓名" min-width="110" align="center">
        <template slot-scope="scope">{{ scope.row.name }}</template>
      </el-table-column>
      <el-table-column label="联系人电话" min-width="110" align="center">
        <template slot-scope="scope">{{ scope.row.phone }}</template>
      </el-table-column>
      <el-table-column label="标题" min-width="110" align="center">
        <template slot-scope="scope">{{ scope.row.product.title }}</template>
      </el-table-column>
      <el-table-column label="总价" min-width="110" align="center">
        <template slot-scope="scope">{{ scope.row.total_price }}</template>
      </el-table-column>
      <el-table-column label="类型" min-width="110" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.product.type == 2">路线</span>
          <span v-else>套餐</span>
        </template>
      </el-table-column>
      <el-table-column class-name="status-col" label="订单状态" min-width="110" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.order_status == 0">待付款</span>
          <span v-else-if="scope.row.order_status == 1">进入拼团状态</span>
          <span v-else-if="scope.row.order_status == 2">待使用</span>
          <span v-else-if="scope.row.order_status == 3">进入预约状态</span>
          <span v-else-if="scope.row.return_status != 3&&scope.row.order_status == 4">使用中</span>
          <span v-else-if="scope.row.order_status == 5">完成</span>
          <span v-else-if="scope.row.order_status == 8">已过期</span>

          <span
            v-else-if="scope.row.pay_status != 3&&scope.row.return_status == 0&&scope.row.order_status == 7"
          >已关闭</span>
          <span v-else-if="scope.row.return_status == 1">
            <el-tag>售后待处理</el-tag>
          </span>
          <span v-else-if="scope.row.return_status == 2">
            <el-tag type="success">售后成功</el-tag>
          </span>
          <span v-else-if="scope.row.pay_status != 3&&scope.row.return_status == 3">
            <el-tag type="danger">售后失败</el-tag>
          </span>

          <span v-else-if="scope.row.return_status == 0&&scope.row.pay_status == 2">
            <el-tag type="success">待退款</el-tag>
          </span>
          <span v-else-if="scope.row.pay_status == 3">
            <el-tag type="danger">已退款 </el-tag>
          </span>
        </template>
      </el-table-column>
      <el-table-column label="支付状态" min-width="110" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.pay_status === 0">未支付</span>
          <span v-else-if="scope.row.pay_status === 1">已支付</span>
          <span v-else-if="scope.row.pay_status === 2">待退款</span>
          <span v-else-if="scope.row.pay_status === 3">已退款</span>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="pay_datetime" label="下单时间" min-width="140">
        <template slot-scope="scope">
          <i class="el-icon-time" />
          <span>{{ scope.row.pay_datetime }}</span>
        </template>
      </el-table-column>

      <el-table-column label="操作" align="center" width="230" class-name="small-padding fixed-width">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="primary"
            @click="afterSales(scope.row.order_no)"
            v-if="scope.row.return_status == 1"
          >查看售后</el-button>
          <el-button
            size="mini"
            type="primary"
            @click="handleCreate(scope.row.order_no)"
            v-else
          >查看详情</el-button>
          <!-- <el-button
            size="mini"
            type="success"
            @click="handleChange(scope.row.id)"
            v-if="scope.row.order_status == 2 && scope.row.product.type == 2"
          >设为已使用</el-button> -->
          <el-button
            size="mini"
            type="warning"
            @click="refund(scope.row.order_no)"
            v-if="scope.row.order_status != 6 &&scope.row.order_status != 5 &&scope.row.order_status != 7&&scope.row.pay_status==1"
          >退款</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination
        :current-page="listQuery.page"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="listQuery.limit"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
import { getQiniuToken } from "@/api/common";
import request from "@/utils/request";
import { guid, base64toFile } from "@/utils/index";
import "babel-polyfill"; // es6 shim
import imgCropUpload from "vue-image-crop-upload";
import uploadList from "@/components/UploadList/index.vue";
import * as qiniu from "qiniu-js";
import AMapPosition from "@/components/AMapPosition";

export default {
  components: {
    "img-crop-upload": imgCropUpload,
    "amap-position": AMapPosition,
    uploadList
  },
  data() {
    return {
      temp: [],
      list: null,
      total: null,
      listLoading: true,
      refuseInfo: {
        refuse_reason: "",
        order_no: ""
      },
      showDetails: { product_snap: { product_package: [{}] } },
      info: {
        product_snap: { product_package: [{}] },
        order_return: {}
      },
      order_no: null,
      listQuery: {
        page: 1,
        limit: 10,
        shop_name: "",
        order_no: "",
        title: "",
        name: "",
        phone: "",
        type: "",
        order_status: ""
      },
      dialogFormVisible: false,
      dialogFormVisible1: false,
      reasonVisible: false,
      dialogStatus: "",
      textMap: {
        update: "编辑",
        create: "添加"
      },
      dialogPvVisible: false,
      appointmentVisible: false,
      pvData: [],
      form: {
        id: "",
        img: "",
        imgArray: [],
        link_type: 0,
        link: "",
        weight: 0,
        description: ""
      },
      rules: {
        img: [{ required: true, message: "图片不能为空", trigger: "blur" }]
      },
      btnLoading: false,

      show: false,
      imgBase64Data: "" // the datebase64 url of created image
    };
  },
  created() {
    this.getList();
  },
  methods: {
    upAppointmentIndex(index) {
      console.log(index);
    },
    getList() {
      this.listLoading = true;
      request({
        url: "/api/backend/order",
        method: "get",
        params: this.listQuery
      }).then(response => {
        this.list = response.data.data;
        this.total = response.data.total;
        this.listLoading = false;
      });
    },
    handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    handle(order_no) {
      this.appointmentVisible = true;
      this.order_no = order_no;
    },
    // handleChange(id) {
    //   request({
    //     url: "/api/backend/orderStatusChange",
    //     method: "get",
    //     params: { id: id }
    //   }).then(response => {
    //     this.getList();
    //   });
    // },
    search() {
      this.listQuery.page = 1;
      this.getList();
    },
    use(id, type, order_no) {
      request({
        url: "/api/backend/order/use",
        method: "get",
        params: { id: id, type: type }
      }).then(response => {
        this.btnLoading = false;
        this.$notify({
          title: "成功",
          message: "使用成功",
          type: "success",
          duration: 2000
        });

        this.handleCreate(order_no);
      });
    },
    resetForm() {
      this.form = {
        id: "",
        img: "",
        imgArray: [],
        link_type: 0,
        link: "",
        weight: 0,
        description: ""
      };
      this.btnLoading = false;
    },

    handleCreate(order_no) {
      this.$router.push("/order/viewDetails?order_no=" + order_no);
    },
    handleReason(order_no) {
      this.refuseInfo = {
        refuse_reason: "",
        order_no: ""
      };
      this.refuseInfo.order_no = order_no;
      this.reasonVisible = true;
    },
    refuse() {
      request({
        url: "/api/backend/orderReturn/cancel",
        method: "post",
        data: this.refuseInfo
      }).then(response => {
        this.reasonVisible = false;
        this.dialogFormVisible1 = false;
        this.getList();
      });
    },
    pass(order_no) {
      request({
        url: "/api/backend/orderReturn/handle",
        method: "post",
        data: { order_no: order_no }
      }).then(response => {
        this.reasonVisible = false;
        this.dialogFormVisible1 = false;
        this.getList();
      });
    },
    afterSales(order_no) {
      this.$router.push("/order/checkAfterSales?order_no=" + order_no);
    },
    // pass(order_no) {
    //   request({
    //     url: "/api/backend/order/refund",
    //     method: "post",
    //     data: { order_no: order_no }
    //   }).then(response => {
    //     this.getList();
    //   });
    // },
    refuseAppointment() {
      request({
        url: "/api/backend/order/refuse",
        method: "post",
        data: { order_no: this.order_no }
      }).then(response => {
        this.$message({
          type: "success",
          message: "驳回成功!"
        });
        this.handleCreate(this.order_no);
        this.appointmentVisible = false;
      });
    },
    passAppointment() {
      request({
        url: "/api/backend/order/agree",
        method: "post",
        data: { order_no: this.order_no }
      }).then(response => {
        this.$message({
          type: "success",
          message: "处理成功!"
        });
        this.handleCreate(this.order_no);
        this.appointmentVisible = false;
      });
    },
    handleUpdate(row) {
      this.resetForm();
      this.form = Object.assign(
        {
          imgArray: [
            "http://img.qkjcrm.com/c9fd9e7a-6e3c-42c7-8c9a-22c20cd3db22.png",
            "http://img.qkjcrm.com/f860dce0-04e4-49c4-926e-4a7a0360c8b0.png"
          ]
        },
        row
      ); // copy obj
      this.dialogStatus = "update";
      this.dialogFormVisible = true;
      this.$nextTick(() => {
        this.$refs["form"].clearValidate();
      });
    },
    handledown(row) {
      this.resetForm();
      this.form = Object.assign(
        {
          imgArray: [
            "http://img.qkjcrm.com/c9fd9e7a-6e3c-42c7-8c9a-22c20cd3db22.png",
            "http://img.qkjcrm.com/f860dce0-04e4-49c4-926e-4a7a0360c8b0.png"
          ]
        },
        row
      ); // copy obj
      this.dialogStatus = "update";
      this.dialogFormVisible1 = true;
      this.$nextTick(() => {
        this.$refs["form"].clearValidate();
      });
    },
    saveData() {
      console.log(this.form, this.form.imgArray);
      return;
      this.$refs["form"].validate(valid => {
        if (valid) {
          this.btnLoading = true;
          request({
            url: "/api/backend/banner/save",
            method: "post",
            data: this.form
          })
            .then(response => {
              this.btnLoading = false;
              this.dialogFormVisible = false;
              this.$notify({
                title: "成功",
                message: "保存成功",
                type: "success",
                duration: 2000
              });
              this.getList();
            })
            .catch(err => {
              this.btnLoading = false;
            });
        }
      });
    },
    handleDel(val) {
      this.$confirm("确定要删除, 是否继续?", "提示", {
        type: "warning"
      })
        .then(() => {
          request({
            url: "/api/backend/banner/del",
            method: "get",
            params: { id: val }
          }).then(() => {
            this.getList();
            this.$message({
              type: "success",
              message: "删除成功!"
            });
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消"
          });
        });
    },
    refund(val) {
      this.$confirm("确定要退款, 是否继续?", "提示", {
        type: "warning"
      })
        .then(() => {
          request({
            url: "/api/backend/order/drawback",
            method: "post",
            data: { order_no: val }
          }).then(() => {
            this.getList();
            this.$message({
              type: "success",
              message: "退款成功!"
            });
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消"
          });
        });
    },
    toggleShow() {
      this.show = !this.show;
    },
    cropSuccess(imgBase64Data, field) {
      console.log("-------- 裁剪成功 --------");
      let that = this;
      this.imgBase64Data = imgBase64Data;
      getQiniuToken().then(response => {
        let file = base64toFile(imgBase64Data, "tmp.png");
        let key = guid() + ".png";
        let token = response.data.token;
        let baseUrl = response.data.baseUrl;
        let putExtra = {};
        let config = {
          useCdnDomain: true,
          region: qiniu.region.z2
        };
        var observable = qiniu.upload(file, key, token, putExtra, config);
        var subscription = observable.subscribe({
          next(res) {
            // ...
          },
          error(err) {
            // ...
          },
          complete(res) {
            // ...
            let imgUrl = baseUrl + "/" + key;
            that.form.img = imgUrl;
            console.log(imgUrl);
          }
        }); // 上传开始
        // or
        // var subscription = observable.subscribe(next, error, complete) // 这样传参形式也可以
        // subscription.unsubscribe() // 上传取消
      });
    }
  }
};
</script>

<style>
.upload-block {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 120px;
  height: 120px;
}
.uploaded-img {
  width: 120px;
  height: 120px;
}
.upload-block:hover {
  border-color: #409eff;
}
.uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 120px;
  height: 120px;
  line-height: 120px;
  text-align: center;
}
.user-avatar {
  width: 40px;
  height: 40px;
  border-radius: 6px;
}
</style>
